import { useMutation, useQueryClient } from 'react-query';
import { DateTime } from 'luxon';
import { accreditationsService } from 'ogp/services';
import { QUERY_KEYS } from 'api/query-keys';

export const useUpdateCertificateValidUntil = (flexWorkerId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ accreditationId, validUntil }: { accreditationId: string; validUntil: DateTime | null }) =>
      accreditationsService.updateCertificateValidUntil(flexWorkerId, accreditationId, validUntil),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.employeeCertificates(flexWorkerId));
      },
    }
  );
};
